import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBank: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBank"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0015 1.65967L2.00151 6.71164V9.99994H4.00151V16.4999H3.21094L1.71094 20.9999H22.2921L20.7921 16.4999H20.0015V9.99994H22.0015V6.71164L12.0015 1.65967ZM16.0015 9.99994H18.5015V16.4999H16.0015V9.99994ZM8.00151 16.4999H5.50151V9.99994H8.00151V16.4999ZM9.50151 16.4999V9.99994H14.5015V16.4999H9.50151Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBank;
